import { Injectable } from '@angular/core';
import {
  NoticeOfPrivacyPracticesApi,
  NppSetupStatus,
  UpdateNoticeOfPrivacyPracticesRequest,
} from '@models';
import { delay, Observable, of } from 'rxjs';
import { NoticeOfPrivacyPracticesService } from './notice-of-privacy-practices.interface';

@Injectable({
  providedIn: 'root',
})
export class NoticeOfPrivacyPracticesMockService
  implements NoticeOfPrivacyPracticesService
{
  private notice: NoticeOfPrivacyPracticesApi = {
    noticeName: 'Notice of Privacy Practices',
    language: 'en',
    contentHtml:
      '<p><strong>THIS NOTICE DESCRIBES HOW MEDICAL INFORMATION ABOUT YOU MAY BE USED AND DISCLOSED AND HOW YOU CAN GET ACCESS TO THIS INFORMATION. PLEASE REVIEW IT CAREFULLY.</strong></p>' +
      '<p><strong>Practice:</strong> Dr. Anna Bogdan Health &amp; Wellness<br>' +
      '<strong>Address:</strong> 350 5th Ave, New York, NY 10118<br>' +
      '<strong>Privacy contact:</strong> Dr. John Smith, Account Owner · +1 (503) 772-9895 · privacy@healthllc.com<br>' +
      '<strong>Effective date:</strong> Jun 19, 2026</p>' +
      '<p>We are required by law to maintain the privacy of your protected health information and to provide you with this Notice of Privacy Practices.</p>' +
      '<h2>Our uses and disclosures</h2>' +
      '<p>We may use and share your health information to treat you, run our practice, bill for services, and comply with law.</p>' +
      '<h2>Your rights</h2>' +
      '<p>You have the right to get a copy of your medical record, request corrections, and request a paper copy of this notice at any time.</p>',
    providerConfirmed: false,
    status: NppSetupStatus.Draft,
    canPublish: false,
    publishedVersion: 0,
    effectiveDateUtc: null,
    publishedAtUtc: null,
    updatedAtUtc: '2026-06-19T00:00:00Z',
  };

  getNotice(): Observable<NoticeOfPrivacyPracticesApi> {
    return of(this.notice).pipe(delay(300));
  }

  saveDraft(
    body: UpdateNoticeOfPrivacyPracticesRequest
  ): Observable<NoticeOfPrivacyPracticesApi> {
    const contentChanged =
      body.noticeName !== undefined ||
      body.language !== undefined ||
      body.contentHtml !== undefined;
    const providerConfirmed =
      body.providerConfirmed ??
      (contentChanged ? false : this.notice.providerConfirmed);

    this.notice = {
      ...this.notice,
      noticeName: body.noticeName ?? this.notice.noticeName,
      language: body.language ?? this.notice.language,
      contentHtml: body.contentHtml ?? this.notice.contentHtml,
      providerConfirmed,
      canPublish: providerConfirmed,
      status:
        contentChanged && this.notice.status === NppSetupStatus.Published
          ? NppSetupStatus.Draft
          : this.notice.status,
    };
    return of(this.notice).pipe(delay(300));
  }

  publish(): Observable<NoticeOfPrivacyPracticesApi> {
    const now = '2026-06-27T00:00:00Z';
    this.notice = {
      ...this.notice,
      status: NppSetupStatus.Published,
      publishedVersion: this.notice.publishedVersion + 1,
      effectiveDateUtc: now,
      publishedAtUtc: now,
    };
    return of(this.notice).pipe(delay(300));
  }
}
